<template>
  <div>
    <el-card style="margin-bottom: 10px;">
      <el-form
        ref="queryFormRef"
        :model="queryForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <!--时间范围-->
            <el-form-item
              :label="$t('CenterForSorting.timeRange')"
              prop="params.dateRange"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: 'change' }
              ]"
            >
              <el-date-picker
                v-model="queryForm.params.dateRange"
                type="datetimerange"
                range-separator="-"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--状态-->
            <el-form-item :label="$t('GlobalSetObj.pushStatus')">
              <el-select
                v-model="queryForm.params.pushStatusList"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                multiple
                style="width: 100%;"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--航空公司-->
            <el-form-item :label="$t('mdfeTranslate.Airline')">
              <el-select
                v-model="queryForm.params.configCode"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                remote
                :remote-method="getAirlineOption"
                style="width: 100%;"
                @visible-change="getAirlineOptionChange"
              >
                <el-option
                  v-for="item in airlineOptions"
                  :key="item.configCode"
                  :label="item.airlineName"
                  :value="item.configCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--目的地-->
            <el-form-item :label="$t('mdfeTranslate.destination')">
              <el-input v-model="queryForm.params.destIata" :placeholder="$t('collectionCenter.pleaseInput')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <!--操作-->
            <el-button type="primary" size="small" @click="queryPage">{{ $t('GlobalSetObj.search') }}</el-button>
            <el-button size="small" @click="resetParam">{{ $t('GlobalSetObj.reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div>
        <!-- 新增推送 -->
        <el-button
          v-permit:remove="'btn:invoiceCenter:pushConfiguration:addPush'"
          type="primary"
          size="small"
          @click="addConfiguration(0)"
        >{{ $t('mdfeTranslate.AddPush') }}</el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:pushConfiguration:addPush'"
          type="primary"
          size="small"
          @click="addConfiguration(1)"
        >{{ $t('mdfeTranslate.BatchImport') }}</el-button>
      </div>
      <div style="margin-top: 10px;">
        <table-column
          :key="tableKey"
          :table-data="tableData"
          :status-options="statusOptions"
          :mdfe-status="mdfeStatus"
          @handleView="handleView"
          @handleFlightPush="handleFlightPush"
        />
        <div class="pagination">
          <!-- 分页工具 -->
          <el-pagination
            :current-page.sync="queryForm.pageNumber"
            :page-size.sync="queryForm.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="margin: 10px 0"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="pushTitle"
      width="500px"
      :visible.sync="dialogVisiblePush"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <form-push
        ref="formDataPushRef"
        :key="formDataKey"
        :form-data="formData"
        :push-type="pushType"
        @savePush="savePush"
        @batchImportResultData="batchImportResultData"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisiblePush = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          size="small" type="primary"
          @click="handlePush"
        >{{ $t('GlobalSetObj.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--详情-->
    <el-dialog
      :title="pushTitle"
      width="660px"
      :visible.sync="showDetailPush"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <detail
        ref="detailPushRef"
        :key="formDataKey"
        :detail-data="detailData"
        :status-options="statusOptions"
        :mdfe-status="mdfeStatus"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDetailPush = false">{{ $t('GlobalSetObj.Close') }}</el-button>
        <el-button
          v-if="showDetailPush && pushType === 4"
          size="small"
          type="primary"
          @click="cancelPush"
        >{{ $t('GlobalSetObj.determine') }}</el-button>
      </div>
    </el-dialog>
    <!--批量导入结果-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('operationCenter.TheResultOfTheOperation')"
      :visible.sync="batchImportResultDialog"
      width="700px"
      @close="cancelConfirm"
    >
      <div>
        <el-row
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-col :span="7">
            <!--  操作总数  -->
            <span style="text-align: left">{{ $t('home.operationTotal') }}：{{ batchImportResult.totalCount }}</span>
          </el-col>
          <el-col :span="7">
            <!--  成功数  -->
            <span style="text-align: left">{{ $t('Resource.successCount') }}：{{ batchImportResult.successCount }}</span>
          </el-col>
          <el-col :span="7">
            <!--  失败数  -->
            <span style="text-align: left">{{ $t('GlobalSetObj.FailureCount') }}：<span style="color: #e02f45">{{
              batchImportResult.failCount
            }}</span></span>
          </el-col>
        </el-row>
        <div v-if="batchImportResult.failRecords.length>0" style="padding: 10px;border: 1px solid #ccc;border-radius: 5px;margin-top: 20px;">
          <div v-for="(item, idx) in batchImportResult.failRecords" :key="idx">
            {{ idx + 1 }}. {{ item.mdfeKey }}：{{ item.failReason }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchImportResultDialog = false">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="pushTitle"
      width="900px"
      :visible.sync="showResendPush"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <resend
        ref="resendPushRef"
        :key="formDataKey"
        :push-type="pushType"
        :detail-data="detailData"
        :status-options="statusOptions"
        :mdfe-status="mdfeStatus"
        @resendPushSave="resendPushSave"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showResendPush = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          size="small" type="primary"
          @click="handleResendPush"
        >{{ $t('GlobalSetObj.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import tableColumn from './cmp/tableColumn.vue';
import formPush from './cmp/form.vue';
import detail from './cmp/detail.vue';
import resend from './cmp/resend.vue';
import {
  airlineCancelPush,
  airlinePushConfigPageQueryOptions,
  airlinePushRecordPageQuery
} from '@/api/invoiceCenter';
export default {
  name: 'AirlinePushRecords',
  components: { tableColumn, formPush, detail, resend },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          pushStatusList: [],
          configCode: null,
          destIata: null,
          dateRange: []
        }
      },
      startDate: null, // 存储第一次选中的日期
      pickerOptions: {
        // 注意：这里不能直接用箭头函数，需要保存 this 引用
        onPick: ({ minDate, maxDate }) => {
          // 当用户选择了第一个日期（开始日期）时，记录它
          if (minDate && !maxDate) {
            this.startDate = minDate;
          }
          // 当用户选择了第二个日期（结束日期）时，清空记录
          if (minDate && maxDate) {
            this.startDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果没有选择开始日期，不禁用任何日期
          if (!this.startDate) return false;

          // 计算前后一个月的边界
          const start = new Date(this.startDate);
          const minTime = new Date(start.getTime() - 30 * 24 * 60 * 60 * 1000);
          const maxTime = new Date(start.getTime() + 30 * 24 * 60 * 60 * 1000);

          // 禁用边界之外的日期
          return time.getTime() < minTime.getTime() || time.getTime() > maxTime.getTime();
        }
      },
      airlineOptions: [],
      statusOptions: {
        0: {
          label: this.$t('mdfeTranslate.PendingPush'), // '待推送',
          value: 0
        },
        1: {
          label: this.$t('mdfeTranslate.Pushed'), // '已推送',
          value: 1
        },
        2: {
          label: this.$t('mdfeTranslate.PushFailed'), // '推送失败',
          value: 2
        },
        3: {
          label: this.$t('mdfeTranslate.Canceled'), // '已取消',
          value: 3
        }
      },
      mdfeStatus: {
        1: {
          label: this.$t('mdfeTranslate.Authorized'),
          value: 1
        },
        2: {
          label: this.$t('collectionCenter.cancelled'),
          value: 2
        },
        3: {
          label: this.$t('mdfeTranslate.Closed'),
          value: 3
        }
      },
      destinationOptions: [],
      tableKey: new Date().getTime(),
      tableData: [],
      total: 0,
      dialogVisiblePush: false,
      formData: {
        configCode: null,
        mdfeKey: null,
        id: null
      },
      formDataKey: new Date().getTime(),
      pushType: 0,
      pushTitle: '',
      showResendPush: false,
      detailData: null,
      batchImportResultDialog: false,
      batchImportResult: {
        failCount: 0,
        successCount: 0,
        totalCount: 0,
        failRecords: []
      },
      showDetailPush: false
    };
  },
  created() {
    const currentDate = dayjs().format('YYYY-MM-DD');
    this.queryForm.params.dateRange = [currentDate + ' 00:00:00', currentDate + ' 23:59:59'];
    this.$nextTick(() => {
      this.queryPage();
    });
  },
  methods: {
    // 取消推送
    cancelPush() {
      this.$confirm(this.$t('mdfeTranslate.wantToCancelThePush') + ' "' + this.detailData.airlineName + '" ?', this.$t('mdfeTranslate.CancelPush'), {
        confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
        cancelButtonText: this.$t('orderCenterCont.cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          pushOrderNumber: this.detailData.pushOrderNumber
        };
        airlineCancelPush(param).then(res => {
          if (res.code === 200) {
            if (res.data.success) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.getPushList();
              this.showDetailPush = false;
            } else {
              this.$message.success(res.data.failReason || this.$t('operationCenter.operationFailed'));
            }
          }
        });
      });
    },
    // 关闭结果
    cancelConfirm() {
      this.batchImportResultDialog = false;
      this.dialogVisiblePush = false;
      this.getPushList();
    },
    // 批量导入结果
    batchImportResultData(data) {
      this.batchImportResultDialog = true;
      this.batchImportResult = data;
    },
    // 打开选择公司弹窗
    getAirlineOptionChange(val) {
      if (val) {
        this.getAirlineOption();
      }
    },
    // 获取航空公司选项
    getAirlineOption(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          airlineName: name
        }
      };
      airlinePushConfigPageQueryOptions(param).then(res => {
        if (res.code === 200) {
          this.airlineOptions = res.data.records;
        }
      });
    },
    // 搜索
    queryPage() {
      this.queryForm.pageNumber = 1;
      this.getPushList();
    },
    // 获取推送列表数据
    getPushList() {
      this.$refs.queryFormRef.validate(valid => {
        if (valid) {
          const params = {
            pageNumber: this.queryForm.pageNumber,
            pageSize: this.queryForm.pageSize,
            params: {
              pushStatusList: this.queryForm.params.pushStatusList,
              configCode: this.queryForm.params.configCode,
              destIata: this.queryForm.params.destIata,
              startTime: this.queryForm.params.dateRange[0],
              endTime: this.queryForm.params.dateRange[1]
            }
          };
          airlinePushRecordPageQuery(params).then(res => {
            if (res.code === 200) {
              this.tableData = res.data.records;
              this.total = res.data.total;
              this.tableKey = new Date().getTime();
            }
          });
        }
      });
    },
    // 重置搜索条件
    resetParam() {
      this.queryForm.params = {
        pushStatusList: [],
        configCode: null,
        destIata: null,
        dateRange: []
      };
      const currentDate = dayjs().format('YYYY-MM-DD');
      this.queryForm.params.dateRange = [currentDate + ' 00:00:00', currentDate + ' 23:59:59'];
      this.queryPage();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getPushList();
    },
    // 改变每页显示数量
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getPushList();
    },
    // 新增推送
    addConfiguration(type) {
      // type: 0新增 1批量新增
      this.pushType = type;
      if (type === 0) {
        this.pushTitle = this.$t('mdfeTranslate.AddPush');
      } else {
        this.pushTitle = this.$t('mdfeTranslate.BatchImport');
      }
      this.formData = {
        configCode: null,
        mdfeKey: null
      };
      this.dialogVisiblePush = true;
      this.formDataKey = new Date().getTime();
    },
    // 确认推送
    handlePush() {
      this.$refs.formDataPushRef.savePush();
    },
    // 推送成功后更新数据
    savePush(type) {
      if (type) {
        this.getPushList();
      }
      this.dialogVisiblePush = false;
    },
    // 详情
    handleView(row, type) {
      this.pushType = type;
      this.pushTitle = type === 5 ? this.$t('mdfeTranslate.PushDetails') : this.$t('mdfeTranslate.CancelPush');
      this.detailData = row;
      this.showDetailPush = true;
      this.formDataKey = new Date().getTime();
    },
    // 打开航空推送弹窗
    handleFlightPush(row, type) {
      this.pushType = type;
      this.pushTitle = type === 2 ? this.$t('mdfeTranslate.AviationPush') : this.$t('mdfeTranslate.RePush');
      this.detailData = { ...row, startState: null, endState: null };
      this.showResendPush = true;
      this.formDataKey = new Date().getTime();
    },
    // 确认推送
    handleResendPush() {
      this.$refs.resendPushRef.handleResendPush();
    },
    resendPushSave(type) {
      if (type) {
        this.getPushList();
      }
      this.showResendPush = false;
    }
  }
};
</script>

<style scoped>

</style>
